import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import SessionsService from "@services/SessionsService";

export const viewScenarioSession = createAsyncThunk(
  "scenario-session/view",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await SessionsService.viewScenarioSession({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const viewProductSession = createAsyncThunk(
  "product-session/view",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await SessionsService.viewProductSession({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const viewCertificationSession = createAsyncThunk(
  "certification-session/view",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await SessionsService.viewCertificationSession({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const deleteScenarioSession = createAsyncThunk(
  "scenario-session/delete",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await SessionsService.deleteScenarioSession({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const deleteProductSession = createAsyncThunk(
  "product-session/delete",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await SessionsService.deleteProductSession({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const deleteCertificationSession = createAsyncThunk(
  "certification-session/delete",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await SessionsService.deleteCertificationSession({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  current: null,
  errors: null,
  error: "",
  status: "",
};

const viewSessionSlice = createSlice({
  name: "view-session",
  initialState,
  reducers: {
    setCurrent(state, action) {
      state.current = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearView() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteScenarioSession.pending, (state) => {
        pendingState(state);
      })
      .addCase(deleteScenarioSession.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(deleteScenarioSession.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(deleteCertificationSession.pending, (state) => {
        pendingState(state);
      })
      .addCase(deleteCertificationSession.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(deleteCertificationSession.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(deleteProductSession.pending, (state) => {
        pendingState(state);
      })
      .addCase(deleteProductSession.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(deleteProductSession.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(viewScenarioSession.pending, (state) => {
        pendingState(state);
      })
      .addCase(viewScenarioSession.fulfilled, (state, action) => {
        state.current = action.payload;
        fulfilledState(state);
      })
      .addCase(viewScenarioSession.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(viewCertificationSession.pending, (state) => {
        pendingState(state);
      })
      .addCase(viewCertificationSession.fulfilled, (state, action) => {
        state.current = action.payload;
        fulfilledState(state);
      })
      .addCase(viewCertificationSession.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(viewProductSession.pending, (state) => {
        pendingState(state);
      })
      .addCase(viewProductSession.fulfilled, (state, action) => {
        state.current = action.payload;
        fulfilledState(state);
      })
      .addCase(viewProductSession.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {clearView, setCurrent, setError, setStatus} =
  viewSessionSlice.actions;
export default viewSessionSlice.reducer;
